export default "__VITE_ASSET__c32b6eba__"